export const GradientDecorationLine = ({ height = 4, style = {} }) => {
    return (
        <hr
            style={{
                background: 'linear-gradient(to right, #94C12E, #04BBF1, #1D4370)',
                height,
                border: 'none',
                ...style, // Allows additional styling props
            }}
        />
    );
};  